import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useResolveComplaint from '../../../../hooks/dashboard/BaDriverVerification/useResolveComplaint';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { TableContext } from '../../../Table/TableContext';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { ModalContext } from '../../ModalContext';

interface ComplaintViewActionProps {
  data: any;
}
const ComplaintViewAction: React.FC<ComplaintViewActionProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const tableContext = useContext(TableContext);
  const { resetSliderIndex, setSliderIndexPos, sliderIndex } = useContext(
    TranslatingContainerContext,
  )!;
  const { resolveComplaint, loading } = useResolveComplaint();

  const onApprove = () => {
    resolveComplaint(data?.id ?? '', () => {
      modalContext?.setShowModal(false);
      tableContext?.setRefreshTable(!tableContext?.refreshTable);
      resetSliderIndex();
    });
  };

  return (
    <Container className={sliderIndex > 1 ? 'inactive' : ''}>
      <Prompt>What action do you want to take on this complaint?</Prompt>

      <ButtonArea>
        <SendMessageButton onClick={() => setSliderIndexPos(1)}>
          Send message
        </SendMessageButton>

        <FormSubmitButton
          className='blue full'
          loading={loading}
          onClick={onApprove}
          btnType='button'
        >
          Approve
        </FormSubmitButton>
      </ButtonArea>
    </Container>
  );
};

export default ComplaintViewAction;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
  padding: 16px;

  &.inactive > * {
    display: none;
  }
`;

const Prompt = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #4b5563;
`;

const ButtonArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

const SendMessageButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  background: white;
  cursor: pointer;
`;
